import classNames from 'classnames';
import React, {memo} from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';

interface IProps {
    className?: string;
}

export const NoImageNew = memo<IProps>(function NoImage({className}) {
    return (
        <div className={classNames(style.noImage, className)} data-skeleton-item={true}>
            <Icon icon={'no-image-new'} />
        </div>
    );
});
